import { Injectable } from "@angular/core";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { IAccountPromiseLookupService } from "../IAccountPromiseLookupService";
import { AutoCompleteLabelValue } from "../../../model/core/AutoCompleteLabelValue";
import { AutoCompleteLabelValuePromiseLookupService } from "./AutoCompleteLabelValuePromiseLookupService";
import { ClientAccountVisibilityType } from "../../../model/privatization/clientAccountVisibility/ClientAccountVisibilityType";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export abstract class AccountPromiseLookupService
  extends AutoCompleteLabelValuePromiseLookupService<string, CubiqTS.AccountImpl>
  implements IAccountPromiseLookupService
{
  constructor() {
    super();
  }

  abstract getAccount(
    id: string,
    type?: ClientAccountVisibilityType | null,
  ): Promise<CubiqTS.AccountImpl>;
  abstract getAccountsForClient(id: string): Promise<CubiqTS.AccountImpl[]>;
  abstract getClientsForAccount(id: string): Promise<CubiqTS.ClientImpl[]>;
  abstract lookupAccount(
    namePrefix: string,
    maxResults: number,
  ): Promise<Array<CubiqTS.AccountImpl>>;
  abstract lookupAccountsForId(
    namePrefix: string,
    maxResults: number,
  ): Promise<Array<CubiqTS.AccountImpl>>;
  abstract lookupAccountsForName(
    namePrefix: string,
    maxResults: number,
  ): Promise<Array<CubiqTS.AccountImpl>>;
  abstract lookupAccountsForBookingCode(
    namePrefix: string,
    maxResults: number,
  ): Promise<Array<CubiqTS.AccountImpl>>;
  abstract lookupAccountsForContact(
    namePrefix: string,
    maxResults: number,
  ): Promise<Array<CubiqTS.AccountImpl>>;
  abstract lookupAccountsForClient(
    namePrefix: string,
    clientCd: string,
    maxResults: number,
  ): Promise<Array<CubiqTS.AccountImpl>>;
  // break accounts
  abstract getBreakAccounts(salesGroup: string): Promise<Array<CubiqTS.AccountImpl>>;
  abstract getActiveBreakAccounts(
    salesGroup: string,
    onlyFullVisibility?: boolean,
  ): Promise<Array<CubiqTS.AccountImpl>>;
  // active + break accounts
  abstract getBreakAndClientAccounts(
    clientCd: string,
    salesGroup: string,
    onlyFullVisibility?: boolean,
  ): Promise<Array<CubiqTS.AccountImpl>>;
  abstract getActiveBreakAndClientAccounts(
    clientCd: string,
    salesGroup: string,
    onlyFullVisibility?: boolean,
  ): Promise<Array<CubiqTS.AccountImpl>>;
  // active accounts
  abstract getActiveAccount(
    id: string,
    type?: ClientAccountVisibilityType | null,
  ): Promise<CubiqTS.AccountImpl>;
  abstract getActiveAccountsForClient(
    id: string,
    onlyFullVisibility?: boolean,
  ): Promise<CubiqTS.AccountImpl[]>;
  abstract lookupActiveAccountsForId(
    namePrefix: string,
    maxResults: number,
    onlyFullVisibility?: boolean,
  ): Promise<Array<CubiqTS.AccountImpl>>;
  abstract lookupActiveAccountsForName(
    namePrefix: string,
    maxResults: number,
    onlyFullVisibility?: boolean,
  ): Promise<Array<CubiqTS.AccountImpl>>;
  // autofill accounts
  abstract getAutoFillAccount(
    id: string,
    type?: ClientAccountVisibilityType | null,
  ): Promise<CubiqTS.AccountImpl>;
  abstract lookupAutoFillAccountsForId(
    namePrefix: string,
    maxResults: number,
  ): Promise<Array<CubiqTS.AccountImpl>>;
  abstract lookupAutoFillAccountsForName(
    namePrefix: string,
    maxResults: number,
  ): Promise<Array<CubiqTS.AccountImpl>>;
  // BMARK accounts
  abstract lookupBMarkAccountsForId(
    token: string,
    resultSize: number,
    onlyFullVisibility?: boolean,
  ): Promise<Array<CubiqTS.AccountImpl>>;
  abstract lookupBMarkAccountsForName(
    token: string,
    resultSize: number,
    onlyFullVisibility?: boolean,
  ): Promise<Array<CubiqTS.AccountImpl>>;
  // not in use
  //  abstract lookupActiveAccountsForBookingCode(namePrefix:string, maxResults:number):Promise<Array<CubiqTS.AccountImpl>>;
  //  abstract lookupActiveAccountsForContact(namePrefix:string, maxResults:number):Promise<Array<CubiqTS.AccountImpl>>;
  //  abstract lookupActiveAccountsForClient(namePrefix:string, clientCd:string, maxResults:number):Promise<Array<CubiqTS.AccountImpl>>;
}
